import { environment } from '@config/environment'
import { getRichTextNode, MlHeading, TextAlignment } from '@curran-catalog/curran-atomic-library'
import { getNonCmsPageStaticProps, renderNonCmsPage } from '@utils/non-cms-page'
import { useEffect } from 'react'
import { NotFoundPgPage, PgPageProps } from '../[[...slug]]'

export const getStaticProps = getNonCmsPageStaticProps

const CookiePolicy = (props: PgPageProps | NotFoundPgPage) => {
  useEffect(() => {
    const script = document.createElement('script')

    script.src = 'https://consent.cookiebot.com/' + environment.analytics.cookiebotId + '/cd.js'
    script.async = true

    document.getElementById('declarationWrapper')?.appendChild(script)

    return () => {
      document.getElementById('declarationWrapper')?.removeChild(script)
    }
  }, [])

  return renderNonCmsPage(
    'Cookie Policy',
    { ...props, slug: 'customer-service/cookie-policy' },
    <>
      <MlHeading title={getRichTextNode('Cookie Policy', 'heading-1')} textAlignment={TextAlignment.LEFT} />
      <div className="mt-8" id="declarationWrapper" />
    </>,
  )
}

export default CookiePolicy
